import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.css']
})
export class HomeLayoutComponent implements OnInit {

  constructor() {
    console.log("home-layout.component - constructor");
   }

  ngOnInit() {
    console.log("home-layout.component - ngOnInit");
  }

}
